import { useEffect, useState } from 'react';
import { MoreWaysToLearnService } from './more-ways-to-learn';
import { useExperienceContent } from '../../../../hooks/use-server-content';
import { MoreWaysToLearnFragment } from '../../../../models/experiencefragments/dyf-more-ways-to-learn';

export const useMoreWaysToLearn = (
    category: string,
    name: string,
    componentName: string,
    ymmServlet: boolean
): MoreWaysToLearnFragment | null => {
    const [content, setContent] = useState<MoreWaysToLearnFragment | null>(
        null
    );
    const [experienceContent] = useExperienceContent<MoreWaysToLearnFragment>(
        category,
        name,
        componentName,
        undefined,
        ymmServlet
    );
    useEffect(() => {
        if (experienceContent) {
            setContent(
                new MoreWaysToLearnService().getMoreWaysToLearn(
                    experienceContent
                )
            );
        }
    }, [experienceContent]);
    return content;
};
